/**
 * Created by a.marzotta on 16/07/2015.
 */
import angular from 'angular';

const validazioneServiceFactory = function ValidazioneServiceFactory(StorageService, $rootScope, $q, $log, $translate, Environment) {
  "ngInject";
  let messaggiValidazione = {};
  messaggiValidazione = StorageService.getLocalStorageObject('tinabaErrorList');

  return {
    readMessageMap: function() {
      messaggiValidazione = StorageService.getLocalStorageObject('tinabaErrorList');
    },
    getErrorMessage: function(key) {
      return messaggiValidazione[key];
    },
    addBackEndError(key) {
      const messaggio = this.getErrorMessage(key);
      if ((messaggio === undefined || messaggio === "") && Environment.envName !== "debug") {
        $translate("t.app.error.unknownError").then(function(message) { //se non  ho un risultato certo, uso un errore generici dalle translation
          $rootScope.$broadcast("messages:addError", {
            message,
            key
          });
        });
        return;
      } else {
        if ((messaggio === undefined || messaggio === "")) {
          $translate("t.app.error.unknownError").then(function(message) { //se non  ho un risultato certo, uso un errore generici dalle translation
            $rootScope.$broadcast("messages:addError", {
              message,
              key
            });
          });
          return;
        } else {
          $rootScope.$broadcast("messages:addError", {
            message: messaggio,
            key
          });
        }
      }
    },
    addTranslatedError(key, value) {

      $translate(key, value).then(function(message) {
        $rootScope.$broadcast("messages:addError", {
          message
        });
        $log.error(message);
      });

      // },
      // removeErrors() {
      // 	$rootScope.$broadcast("removeErrorMessages");
    },
    addCustomError(message, destinationState, params, action) {
      const eventParams = {
        'message': message,
        'state': destinationState,
        params,
        action
      };
      $rootScope.$broadcast("messages:addError", eventParams);
      // },
      // removeCustomError() {
      // 	$rootScope.$broadcast("removeCustomError");
    },
    addCustomInfo(message, destinationState, params, action) {
      const eventParams = {
        'message': message,
        'state': destinationState,
        params,
        action
      };
      $rootScope.$broadcast("messages:addInfo", eventParams);
      // } ,
      // removeCustomInfo() {
      //  $rootScope.$broadcast("removeCustomInfo");
    },
    addRoboBanner(message, type, additionalData = undefined) {
      const action = type === 'alert-banner-errore' ? 'ShowError' : 'ShowWarning';
      parent.postMessage({action: action, message: message, type: type, step: additionalData}, "*");
    }
  };
};

export default validazioneServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/validazione.factory.js
 **/